import {
  animate,
  AnimationMetadata,
  group,
  query,
  style,
  transition,
  trigger
} from '@angular/animations';

const empresaChildRouteSwap: AnimationMetadata[] = [
  query(
    ':leave',
    [
      style({
        position: 'relative',
        width: '100%',
        zIndex: 1
      })
    ],
    { optional: true }
  ),
  query(
    ':enter',
    [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        opacity: 0,
        transform: 'translateY(16px)',
        zIndex: 2
      })
    ],
    { optional: true }
  ),
  group([
    query(':leave', [animate('300ms ease-out', style({ opacity: 0 }))], { optional: true }),
    query(
      ':enter',
      [animate('300ms ease-in-out', style({ opacity: 1, transform: 'translateY(0)' }))],
      { optional: true }
    )
  ])
];

/**
 * Animación de transición entre subvistas de Empresa.
 *
 * @see https://angular.io/guide/route-animations
 */
export const empresaRouteAnimations = trigger('routeAnimations', [
  transition('Nosotros <=> DataCenter', empresaChildRouteSwap),
  transition('Nosotros <=> FormasPago', empresaChildRouteSwap),
  transition('DataCenter <=> FormasPago', empresaChildRouteSwap),
  transition('Nosotros <=> Terminos', empresaChildRouteSwap),
  transition('DataCenter <=> Terminos', empresaChildRouteSwap),
  transition('FormasPago <=> Terminos', empresaChildRouteSwap),
  transition('Nosotros <=> Reclamos', empresaChildRouteSwap),
  transition('DataCenter <=> Reclamos', empresaChildRouteSwap),
  transition('FormasPago <=> Reclamos', empresaChildRouteSwap),
  transition('Terminos <=> Reclamos', empresaChildRouteSwap)
]);
